const SortBy = ({
  selectedSort,
  onChange,
  isDeliveryAvailable = true,
}: {
  selectedSort?: string;
  onChange: (newVal?: string) => void;
  isDeliveryAvailable?: boolean;
}) => {
  return (
    <div className="text-xs my-auto py-0 whitespace-nowrap w-min">
      <label
        htmlFor={
          isDeliveryAvailable
            ? "delivery-dispensary-sort-select"
            : "pickup-dispensary-sort-select"
        }
      >
        Sort by{" "}
      </label>
      <select
        id={
          isDeliveryAvailable
            ? "delivery-dispensary-sort-select"
            : "pickup-dispensary-sort-select"
        }
        className="text-xs p-0 bg-white w-min"
        onChange={(ev) => onChange(ev.target.value)}
        style={{ appearance: "auto" }}
        value={selectedSort}
        data-testid="sort-by"
      >
        <option value="">Recommended</option>
        {isDeliveryAvailable ? (
          <>
            <option value="delivery-time">Delivery time</option>
            <option value="delivery-fee">Delivery fee</option>
            <option value="delivery-min-order">Delivery minimum</option>
          </>
        ) : (
          <>
            <option value="pickup-distance">Distance</option>
          </>
        )}
      </select>
    </div>
  );
};

export default SortBy;
